import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './utils/extensions';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js'
import "../src/assets/styles/custom-theme.scss";

import App from './App';

// Add Google Analytics script dynamically using the env variable
const addGoogleAnalytics = () => {
  const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
  if (trackingId) {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script.async = true;
    document.head.appendChild(script);
    // Initialize Google Analytics
    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${trackingId}');
    `;
    document.head.appendChild(script2);

  } else {
    console.warn('Google Analytics Tracking ID is not set');
  }
};

addGoogleAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode >
    <App />
  </StrictMode>
);
